import Controller from '../components/Controller';

/**
 * 工具控制器
 */
export default class ToolController extends Controller {
    /**
     * 构造方法，初始化控制器
     * @param   {object}    可选项
     * @returns {undefined}
     */
    constructor(options) {
        super(options);

        /**
         * 当前可用的非排他性工具
         * @type {array}
         */
        this.activeTools = [];
        /**
         * 当前可用的排他性工具
         * @type {object}
         */
        this.mutexTool = null;
    }

    /**
     * 添加工具
     * @param {Object} tool 工具实例
     * @return {undefined}
     */
    add(tool) {
        if (tool) {
            if (tool.isMutex()) {
                this._addMutexTool(tool);
            } else {
                this._addTool(tool);
            }
        }
    }

    /**
     * 删除工具
     * @param {Object} tool 工具实例
     * @return {undefined}
     */
    delete(tool) {
        if (tool) {
            if (tool.isMutex()) {
                this._deleteMutexTool(tool);
            } else {
                this._deleteTool(tool);
            }
        }
    }

    /**
     * 清空控制器中的所有工具
     */
    clear() {
        this._deleteMutexTool();

        this.activeTools.forEach(item => {
            item.onRemove();
        });
        this.activeTools = [];
    }

    /**
     * 添加排他性的工具
     * @param {Object} tool 工具实例
     * @return {undefined}
     */
    _addMutexTool(tool) {
        if (this.mutexTool !== tool) {
            this._deleteMutexTool();
            
            tool.onAdd(this);

            this.mutexTool = tool;
        }
    }

    /**
     * 添加非排他性的工具
     * @param {Object} tool 工具实例
     * @return {undefined}
     */
    _addTool(tool) {
        const existed = this.activeTools.find(item => item === tool);
        if (existed) {
            return;
        }
        
        tool.onAdd(this);

        this.activeTools.push(tool);
    }

    /**
     * 删除排他性的工具
     * @param {Object} tool 工具实例
     * @return {undefined}
     */
    _deleteMutexTool(tool = this.mutexTool) {
        if (this.mutexTool && this.mutexTool === tool) {
            this.mutexTool.onRemove();
            this.mutexTool = null;
        }
    }

    /**
     * 删除非排他性的工具
     * @param {Object} tool 工具实例
     * @return {undefined}
     */
    _deleteTool(tool) {
        const existIndex = this.activeTools.indexOf(tool);
        if (existIndex >= 0) {
            this.activeTools[existIndex].onRemove();

            this.activeTools.splice(existIndex, 1);
        }
    }
}
